<template>
    <div class="map-progress-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 267 170">
            <path :style="{fill: color}"
                  d="M124,0C187.53,0,240.79,48.26,247.3,111.74l.64,12.73H267L221.65,170,176.3,124.47h19.38a71.72,71.72,0,0,0-143.43,0H0C0,55.73,55.5,0,124,0"/>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 267 170" class="whitener" :style="{opacity: whiten}">
            <path d="M124,0C187.53,0,240.79,48.26,247.3,111.74l.64,12.73H267L221.65,170,176.3,124.47h19.38a71.72,71.72,0,0,0-143.43,0H0C0,55.73,55.5,0,124,0"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: "MapProgressArrow",
    props: {
        color: {
            type: String,
            default: '#333333',
        },
        whiten: {
            type: Number,
            default: 0,
        }
    }
}
</script>

<style lang="scss" scoped>
.map-progress-arrow{
    position: relative;
}
.whitener{
    fill: white;
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}
</style>
